import type { Action as ReduxAction } from 'redux';
import { call, put, select, takeLatest } from 'redux-saga/effects';

import { SELECT_DEALER } from 'constants/ActionTypes';
import { PATH } from 'constants/RoutesConstants';
import { scopeToPage } from 'modules/app/sagas/utils';
import * as actions from 'modules/kiosks/actions';
import * as types from 'modules/kiosks/actionTypes';
import { DASHBOARD_SOURCE } from 'modules/kiosks/constants';
import { getBaseRequestParams } from 'modules/kiosks/selectors';

const onFilterChange = ({ type }: ReduxAction) =>
  [
    SELECT_DEALER,
    types.SET_KIOSKS_DASHBOARD_FILTER,
    types.CLEAR_KIOSKS_DASHBOARD_FILTER,
    types.REMOVE_KIOSKS_DASHBOARD_FILTER,
  ].includes(type);

function* refreshDashboard() {
  const { page: _, ...params }: ReturnType<typeof getBaseRequestParams> = yield select(getBaseRequestParams);
  yield put(actions.fetchKiosks({ ...params, page: 0 }, { source: DASHBOARD_SOURCE }));
}

function* onDashboardWorker() {
  yield call(refreshDashboard);
  yield takeLatest(onFilterChange, refreshDashboard);
}

export default function* kiosksDashboardSaga() {
  yield scopeToPage([PATH.KIOSKS], onDashboardWorker);
}
